import { render, staticRenderFns } from "./ErrorModal404.vue?vue&type=template&id=1210e6da&%3Aclass=classes()&"
import script from "./ErrorModal404.vue?vue&type=script&lang=js&"
export * from "./ErrorModal404.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports